// extracted by mini-css-extract-plugin
module.exports = {"adBanner":"styles_adBanner__AZCT4","card":"styles_card__kkfna","fadeInUp":"styles_fadeInUp__bzM8p","image":"styles_image__piEpO"};